import { render, staticRenderFns } from "./ModifierVin.vue?vue&type=template&id=85f17576&"
import script from "./ModifierVin.vue?vue&type=script&lang=js&"
export * from "./ModifierVin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PROJETS\\VITISSIA\\2024\\vitissiapro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85f17576')) {
      api.createRecord('85f17576', component.options)
    } else {
      api.reload('85f17576', component.options)
    }
    module.hot.accept("./ModifierVin.vue?vue&type=template&id=85f17576&", function () {
      api.rerender('85f17576', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/ModifierVin.vue"
export default component.exports